import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.509 2.6a.626.626 0 0 1 1.1.477l-.812 6.498h5.855c.233 0 .45 0 .623.015.14.013.353.042.547.165l.082.058.091.083c.2.204.313.481.309.77-.004.276-.14.494-.23.626-.1.143-.24.31-.388.49L11.669 21.4a.625.625 0 0 1-1.1-.477l.812-6.498H5.526c-.232 0-.45 0-.623-.015-.16-.014-.414-.05-.628-.223a1.076 1.076 0 0 1-.4-.853l.008-.1c.03-.229.143-.41.223-.526.098-.143.238-.31.387-.49L12.51 2.6ZM5.453 13.02l-.128.154h6.765a.626.626 0 0 1 .62.704l-.636 5.083 6.652-7.98.128-.156H12.09a.625.625 0 0 1-.62-.703l.636-5.084-6.652 7.982Z"
    />
  </svg>
`;
